import { useTranslation } from 'react-i18next'

import { PaymentMethod } from '@/api/payments/types/CreatePaymentLinkPayload'
import ApplePayIcon from '@/components/icons/apple-pay.svg?react'
import CreditCardIcon from '@/components/icons/credit-card.svg?react'
import GooglePayIcon from '@/components/icons/google-pay.svg?react'
import bitImg from '@/imgs/bit.png'

import { OptionCard } from './OptionCard'

interface Props {
  selectedPaymentMethod: PaymentMethod
  onSelectPaymentMethod: (method: PaymentMethod) => void
  /** Bit requires at least 5 ₪; hide/disable when amount due is below threshold. */
  bitOptionDisabled?: boolean
}

export const PaymentOptionList = ({ selectedPaymentMethod, onSelectPaymentMethod, bitOptionDisabled }: Props) => {
  const { t } = useTranslation()

  return (
    <div className='space-y-4'>
      <h3 className='text-text-primary text-sm font-medium'>{t('payment.paymentOptionsTitle')}</h3>
      <OptionCard
        onSelect={() => onSelectPaymentMethod(PaymentMethod.CreditCard)}
        selected={selectedPaymentMethod === PaymentMethod.CreditCard}
        title='כרטיס אשראי'
        endContent={<CreditCardIcon />}
      />
      <OptionCard
        onSelect={() => onSelectPaymentMethod(PaymentMethod.GooglePay)}
        selected={selectedPaymentMethod === PaymentMethod.GooglePay}
        title='Google Pay'
        endContent={<GooglePayIcon />}
      />
      {/* {isSafari && ( */}
      <OptionCard
        className='flex h-[58px] items-center'
        onSelect={() => onSelectPaymentMethod(PaymentMethod.ApplePay)}
        selected={selectedPaymentMethod === PaymentMethod.ApplePay}
        title='Apple Pay'
        endContent={<ApplePayIcon className='w-9' />}
      />
      {/* )} */}
      <OptionCard
        onSelect={() => onSelectPaymentMethod(PaymentMethod.Bit)}
        selected={selectedPaymentMethod === PaymentMethod.Bit}
        title={t('payment.payWithBit')}
        description={bitOptionDisabled ? t('payment.bitMinimumAmount') : undefined}
        disabled={bitOptionDisabled}
        endContent={<img src={bitImg} alt='' className='w-6' />}
      />
    </div>
  )
}
